import { Modifier } from '@dnd-kit/core/dist/modifiers';
import dayjs from 'dayjs';
import { TaskGroup, TaskItem } from './TasksList.types';

/**
 * Mirrors the window the task tiles are counted in *server-side*:
 * BpmTaskService.getMinimumCreateTime() -> start of last year, unbounded above.
 * The counts endpoint takes no date parameters, so there is no way to derive
 * this from the response: it has to be kept in sync by hand. If you change
 * getMinimumCreateTime(), change this too.
 */
export const getTaskCountsWindow = () => {
  const today = dayjs();
  return {
    startDate: today.subtract(1, 'year').startOf('year').format('YYYY-MM-DD'),
    endDate: today.format('YYYY-MM-DD')
  };
};

const highestCountItem = (items: TaskItem[]) => {
  return items.reduce((maxItem, curr) => {
    return curr.count > maxItem.count ? curr : maxItem;
  });
};

export const getAllMaxItems = (data: TaskGroup[]) => {
  return data
    .map(({ items, key }) => {
      const itemMax = highestCountItem(items);
      return { ...itemMax, key };
    })
    .filter((item) => item.count > 0);
};

export const restrictToElement = (element: HTMLElement | null): Modifier => {
  return ({ transform, activeNodeRect }) => {
    if (!element || !activeNodeRect) return transform;

    const bounds = element.getBoundingClientRect();

    const x = Math.min(
      Math.max(transform.x, bounds.left - activeNodeRect.left),
      bounds.right - activeNodeRect.right
    );

    const y = Math.min(
      Math.max(transform.y, bounds.top - activeNodeRect.top),
      bounds.bottom - activeNodeRect.bottom
    );

    return { ...transform, x, y };
  };
};
